// import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
// import { faBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
// import { faHandsHeart } from '@fortawesome/pro-regular-svg-icons/faHandsHeart';
// import { faDonate } from '@fortawesome/pro-regular-svg-icons/faDonate';
// import { faWheelchair } from '@fortawesome/pro-regular-svg-icons/faWheelchair';
// import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
// import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
// import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
// import { faNewspaper } from '@fortawesome/pro-solid-svg-icons/faNewspaper';
// import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
// import { faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt';
// import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
// import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
// import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
// import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
// import { faFastBackward } from '@fortawesome/pro-light-svg-icons/faFastBackward';
// import { faFastForward } from '@fortawesome/pro-light-svg-icons/faFastForward';
// import { faVolumeUp } from '@fortawesome/pro-light-svg-icons/faVolumeUp';
// import { faVolumeSlash } from '@fortawesome/pro-light-svg-icons/faVolumeSlash';
// import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
// import { faArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
// import { faArrowUp as fasArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
// import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
// import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
// import { faGooglePlusG } from '@fortawesome/free-brands-svg-icons/faGooglePlusG';
// import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
// import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
// import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';

// config.autoA11y = true;
// config.searchPseudoElements = false;
// config.autoReplaceSvg = false;

// const font_awesome_icons = [faBriefcase, faHandsHeart, faDonate, faWheelchair, faSearch, faArrowUp, faArrowDown, faNewspaper, faEnvelope, faMapMarkerAlt, faCalendarAlt, faClock, faCircle, faPlay, faPause, faFastBackward, faFastForward, faVolumeUp, faVolumeSlash,
//                             faFacebookF, fasArrowUp, faTwitter, faYoutube, faGooglePlusG, faLinkedinIn, faCheck, faBars, faTimesCircle];

// font_awesome_icons.map(icon => library.add(icon));

// dom.watch();
